import React, { memo } from 'react';

import { Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { listItemStyles, subStepListContainerStyles } from './ListContent.styles';

const ListContent = ({ contentProps }) => (
  <Stack sx={subStepListContainerStyles}>
    {contentProps.items.map(({ id, text }) => (
      <Typography key={id} sx={listItemStyles} variant="regular12">
        {text}
      </Typography>
    ))}
  </Stack>
);

ListContent.propTypes = {
  contentProps: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default memo(ListContent);
